var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  var m0 = require("@/static/personalCenter/nostrategy.png")

  var m3 = require("@/static/personalCenter/verityFeedback.png")

  var m4 = require("@/static/personalCenter/submit.png")

  var l0 = _vm.__map(_vm.myStrategyList, function(item, index) {
    var m1 = _vm.$getImg(item.coverImagesUrl)
    var m2 = _vm.formatTime(item.pushTime)
    return {
      $orig: _vm.__get_orig(item),
      m1: m1,
      m2: m2
    }
  })

  _vm.$mp.data = Object.assign(
    {},
    {
      $root: {
        m0: m0,
        m3: m3,
        m4: m4,
        l0: l0
      }
    }
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }